import type { CSSProperties } from "react";
import { tokens } from "../theme";

const style: CSSProperties = {
  alignSelf: "center",
  color: tokens.text.muted,
  fontSize: tokens.font.size.xs,
  fontWeight: tokens.font.weight.medium,
  letterSpacing: "0.02em",
  lineHeight: tokens.font.lineHeight.tight,
  padding: `${tokens.space[1]} 0`,
  userSelect: "none",
};

export default function MessageTimestamp({ label }: { label: string }) {
  return (
    <div role="separator" style={style}>
      {label}
    </div>
  );
}
